// @flow
import React, { Component } from 'react';
import { Link } from 'react-router';

import MobileDropdown from '../MobileDropdown';
import logo from '../Sidebar/logo.svg';

import style from './style.css';

type Props = {
  pathname: string;
  version: string;
  index: Object;
};

export default class SidebarMobile extends Component<void, Props, void> {
  render() {
    const { pathname, version, index } = this.props;
    let xPos = '20px';
    let size = '59px';
    const showDropdown = pathname.match(/\/guide\//)
    || pathname.match(/\/api\//);

    if (pathname.match(/\/guide\//)) {
      xPos = 'calc(100vw - 180px)';
      size = '80px';
    } else if (pathname.match(/\/api\//)) {
      xPos = 'calc(100vw - 100px)';
      size = '80px';
    }
    return (
      <div className={style.mobileNav}>
        <div className={style.heading}>
          <div className={style.content}>
            <Link
              className={style.logo}
              to="/"
            >
              <img alt="Lux" src={logo} />
            </Link>
            <div className={style.links}>
              <Link
                className={style.link}
                to={`/docs/${version}/guide`}
              >
                Guide
              </Link>
              <Link
                className={style.link}
                to={`/docs/${version}/api`}
              >
                API
              </Link>
            </div>
          </div>
          <span
            className={style.selector}
            style={{
              width: size,
              transform: `translate3d(${xPos}, 0, 0)`,
            }}
          />
        </div>
        {showDropdown && (
          <MobileDropdown
            index={index}
            pathname={pathname}
            version={version}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MobileSidebar/index.jsx